<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title">Aviso de Privacidad</h1>

    <div class="content" v-html="row"></div>
    
    <!-- <div class="content">
      <p>
        En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, Bazaar Flex S.A. DE C.V., con domicilio en Sienita 2074, Colonia Mariano Otero, Zapopan, Jalisco, México, C.P. 45067, pone a su disposición el presente aviso de privacidad.
      </p>

      <br />
      <h5>1. IDENTIDAD Y DOMICILIO DEL RESPONSABLE</h5>
      <p>
        Bazaar Flex S.A. DE C.V. (en adelante, “Bazaar Flex”), con domicilio en Sienita 2074, Colonia Mariano Otero, Zapopan, Jalisco, México, C.P. 45067, es responsable del tratamiento de los datos personales recabados a través de su plataforma www.bazaarflex.com.com.mx.
      </p>

      <br />
      <h5>2. DATOS PERSONALES QUE SE RECABAN</h5>
      <p>
        Recabamos datos personales de identificación, contacto, fiscales y financieros, así como información sobre comportamiento dentro del sitio. Esto incluye nombre completo, correo electrónico, dirección, RFC, datos de pago (tokenizados), historial de compras, preferencias, IP y cookies.
      </p>

      <br />
      <h5>3. FINALIDADES DEL TRATAMIENTO</h5>
      <p>
        Los datos personales serán utilizados para:
      </p>
      <ul>
        <li>Registrar y gestionar cuentas de usuario.</li>
        <li>Procesar pedidos y pagos.</li>
        <li>Emitir comprobantes fiscales.</li>
        <li>Coordinar el envío de productos y atención postventa.</li>
        <li>Contactar al usuario en caso de aclaraciones.</li>
        <li>Cumplir obligaciones legales nacionales e internacionales.</li>
        <li>Enviar comunicaciones comerciales (con consentimiento expreso).</li>
      </ul>

      <br />
      <h5>4. TRANSFERENCIAS DE DATOS</h5>
      <p>
        Sus datos podrán ser compartidos con:
      </p>
      <ul>
        <li>Productores afiliados a Bazaar Flex.</li>
        <li>Proveedores de servicios logísticos y de mensajería.</li>
        <li>Plataformas de pago en línea.</li>
        <li>Autoridades fiscales y aduaneras nacionales o extranjeras, cuando sea legalmente requerido.</li>
      </ul>

      <br />
      <h5>5. DERECHOS ARCO</h5>
      <p>
        Usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento de sus datos. Para ejercer estos derechos, puede comunicarse a contacto@bazaarflex.com.com.mx.
      </p>

      <br>
      <h5>6. USO DE COOKIES Y TECNOLOGÍAS SIMILARES</h5>
      <p>
        Utilizamos cookies para mejorar la experiencia del usuario. Usted puede configurar su navegador para deshabilitarlas, aunque esto podría afectar algunas funcionalidades del sitio.
      </p>

      <br />
      <h5>7. CAMBIOS AL AVISO</h5>
      <p>
        Este aviso puede ser modificado en cualquier momento. Las actualizaciones estarán disponibles en www.bazaarflex.com.com.mx/aviso-de-privacidad.
      </p>

      <br />
      <p>
        Fecha de última actualización: 8/Julio/2025
      </p>
    </div> -->

  </div>
</template>

<script>
export default {
  data(){
    return{
      row:null,
    }
  },

  methods: {
    getData: function(){
      axios.get(tools.url('/api/privacidad')).then((response)=>{
        this.row = response.data.body;
      }).catch((error)=>{
      })
    },
  },

  mounted(){
      this.getData();
  },
}
</script>
